import React from "react";
import { Link } from "react-router-dom";
import PublicLayout from "@/components/PublicLayout";

export default function NotFound({ inApp, code = 404 }) {
  const body = (
    <div className="max-w-lg mx-auto text-center py-24 px-6" data-testid={`error-page-${code}`}>
      <p className="text-7xl font-extrabold pm-gradient-text">{code}</p>
      <h1 className="text-2xl font-extrabold mt-4">{code === 403 ? "You don't have access to this page" : "This page doesn't exist"}</h1>
      <p className="text-[var(--pm-muted)] mt-2">Every Date Matters — but this one couldn't be found.</p>
      <Link to={inApp ? "/dashboard" : "/"} className="pm-btn pm-btn-primary mt-8" data-testid="error-back-btn">Go back</Link>
    </div>
  );
  return inApp ? body : <PublicLayout>{body}</PublicLayout>;
}
